import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
} from 'react';

export type LiveRegionType = {
  message: string;
  setMessage: (msg: string) => void;
  clearMessage: () => void;
};

const LiveRegionContext = createContext<LiveRegionType | undefined>(undefined);

export const LiveRegionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessageState] = useState('');

  const setMessage = useCallback((msg: string) => {
    setMessageState(msg);
  }, []);

  const clearMessage = useCallback(() => {
    setMessageState('');
  }, []);

  return (
    <LiveRegionContext.Provider value={{ message, setMessage, clearMessage }}>
      {/* Visually hidden live region for screen readers */}
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
        }}
      >
        {message}
      </div>
      {children}
    </LiveRegionContext.Provider>
  );
};

export const useLiveRegion = (): LiveRegionType => {
  const context = useContext(LiveRegionContext);
  if (!context) {
    throw new Error('useLiveRegion must be used within a LiveRegionProvider');
  }
  return context;
};
